
function getUserJSON() {
  const user = localStorage.getItem('user');
  return user && JSON.parse(user);
}

export function getUser() {
  return getUserJSON();
}

export async function setUser(res) {
  localStorage.setItem('user', JSON.stringify({...getUser(), ...res}))
}

export function createUser(res) {
  localStorage.setItem('user', JSON.stringify(res));
}

export function removeUser() {
  localStorage.removeItem('user');
}

export function getUserRole() {
  return getUser()?.role
}

export function setUserRole (role) {
  localStorage.setItem('user', JSON.stringify({...getUser(), role: role }))
}

export function getUserId() {
  return  getUser()?.id
}

export function setUserId(id){
  localStorage.setItem('user', JSON.stringify({...getUser(), id: id }));
}

export function getUserImage(){
  return getUser() && getUser().image
}

export function setUserImage(image) {
  localStorage.setItem('user', JSON.stringify({...getUser(), image: image }));
}

export function getUserFirstname(){
  return getUser() && getUser().firstname
}

export function setUserFirstname(firstname) {
  localStorage.setItem('user', JSON.stringify({...getUser(), firstname: firstname }));
}

export function getUserLastname(){
  return getUser() && getUser().lastname
}

export function setUserLastname(lastname) {
  localStorage.setItem('user', JSON.stringify({...getUser(), lastname: lastname }));
}

export function getCompanyTitle() {
  return getUser() && getUser().title
}

export function setCompanyTitle(title) {
  localStorage.setItem('user', JSON.stringify({...getUser(), title: title }));
}

export function getVerified() {
  return getUser() && getUser().verified
}

export function setVerified(verified) {
  localStorage.setItem('user', JSON.stringify({...getUser(), verified: verified }));
}